/* unplugin-vue-components disabled */import script from "./otherInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./otherInfo.vue?vue&type=script&lang=ts&setup=true"

import "./otherInfo.vue?vue&type=style&index=0&id=6987833a&lang=less&scoped=true"

import exportComponent from "/data/liulv-h5/quantum-technology/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6987833a"]])

export default __exports__